module.exports = __webpack_public_path__ + "static/img/p_02.2105a37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/p_02.png
// module id = 605
// module chunks = 1